import './App.css';
import MigrationPage from './component/index';

function App() {
  return (
    <MigrationPage />
  );
}

export default App;
